import { render, staticRenderFns } from "./SpecialOfferMultiItem.vue?vue&type=template&id=995e85da&scoped=true&"
import script from "./SpecialOfferMultiItem.vue?vue&type=script&lang=ts&"
export * from "./SpecialOfferMultiItem.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialOfferMultiItem.vue?vue&type=style&index=0&id=995e85da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995e85da",
  null
  
)

export default component.exports